import React from 'react'

import { Typography, Grid, Box, Card, IconButton } from '@material-ui/core'
import Link from '@material-ui/core/Link'
import { useHistory } from 'react-router-dom'
import ArrowBackIos from '@material-ui/icons/ArrowBackIos'
import { useDispatch } from 'react-redux'
import styles from '../settingsStyles'
import { trackEvent } from '../../../helpers/analytics'

function Copyrights() {
  const classes = styles()
  const history = useHistory()
  const dispatch = useDispatch()
  return (
    <Box className={classes.centerPage}>
      <Grid
        container
        direction="column"
        alignItems="center"
        className={classes.container}
        wrap="nowrap"
      >
        <Grid
          item
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          className={classes.sectionTitle}
        >
          <IconButton
            onClick={() => {
              trackEvent(dispatch, {
                eventName: 'uxp_settings_item_click',
                module: 'Settings',
                object: 'BackButton',
                action: 'Click',
                actionContext: 'Copyrights',
                actionContextValue: 'BackButton',
              })
              history.push('/settings/appinfo')
            }}
            className={classes.backButton}
            aria-label="Back"
          >
            <ArrowBackIos fontSize="small" />
          </IconButton>
          <Typography variant="h1">
            <b>Copyright Information</b>
          </Typography>
        </Grid>
        <Grid item className={classes.fullWidth}>
          <Card className={classes.linksCard}>
            <Grid
              container
              direction="column"
              alignItems="left"
              justifyContent="flex-start"
              spacing={2}
              className={classes.copyrightCard}
            >
              <Grid
                item
                container
                direction="row"
                alignItems="left"
                justifyContent="flex-start"
              ></Grid>
              <Grid item>
                <Typography variant="h2">Copyright</Typography>
              </Grid>
              <Grid item>
                <Typography variant="h6">
                  <Link
                    href="https://www.rutgers.edu/copyright-information"
                    target="_blank"
                    rel="noopener noreferer"
                    onClick={() =>
                      trackEvent(dispatch, {
                        eventName: 'uxp_external_link_click',
                        module: 'Settings',
                        object: 'External Link',
                        action: 'Click',
                        actionContext: 'Copyright',
                        actionContextValue:
                          'https://www.rutgers.edu/copyright-information',
                      })
                    }
                  >
                    Copyright ©
                  </Link>{' '}
                  <Link
                    href="https://www.rutgers.edu"
                    target="_blank"
                    rel="noopener noreferer"
                    onClick={() =>
                      trackEvent(dispatch, {
                        eventName: 'uxp_external_link_click',
                        module: 'Settings',
                        object: 'ExternalLink',
                        action: 'Click',
                        actionContext: 'Copyright',
                        actionContextValue: 'https://www.rutgers.edu',
                      })
                    }
                  >
                    Rutgers, The State University of New Jersey. All rights
                    reserved.
                  </Link>
                </Typography>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Box>
  )
}

export default Copyrights
